import * as moment from 'moment';
import {DateEncoding} from './DateEncoding';
import {Utils} from './Utils';

export enum ExtremityTypeOfInterval {
  NONE = 9,
  START_OF_INTERVAL = 10,
  END_OF_INTERVAL = 11,
  START_AND_END_OF_INTERVAL = 12
}

export class ExtremityHelper {

  static add(origin: ExtremityTypeOfInterval, toBeAdded: ExtremityTypeOfInterval): ExtremityTypeOfInterval {
     if (origin === toBeAdded) {
       return origin;
     }
      switch (toBeAdded) {
        case ExtremityTypeOfInterval.END_OF_INTERVAL:
          if (origin === ExtremityTypeOfInterval.START_OF_INTERVAL) {
            origin = ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL;
            return origin;
          }
          return origin;
        case ExtremityTypeOfInterval.START_OF_INTERVAL:
          if (origin === ExtremityTypeOfInterval.END_OF_INTERVAL) {
            origin = ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL;
            return origin;
          }
          return origin;
        default:
          return ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL;
      }
  }


  static remove( origin: ExtremityTypeOfInterval, toBeRemoved: ExtremityTypeOfInterval ): ExtremityTypeOfInterval {
    if (origin === toBeRemoved) {
    return ExtremityTypeOfInterval.NONE;
    }
    switch (toBeRemoved) {
      case ExtremityTypeOfInterval.END_OF_INTERVAL:
        if (origin === ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL) {
          return ExtremityTypeOfInterval.START_OF_INTERVAL;
        }
        return origin;
      case ExtremityTypeOfInterval.START_OF_INTERVAL:
        if (origin === ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL) {
          return ExtremityTypeOfInterval.END_OF_INTERVAL;
        }
        return origin;
    }
    return ExtremityTypeOfInterval.NONE;
  }

}


export class IntervalAndDelay {



  map = new Map<number, ExtremityTypeOfInterval>();
  m_OriginalEncodedAsLong: number;
  m_EncodedAsBinaryString: string;


  public static create(encodedAsLong: number): IntervalAndDelay {
    return new IntervalAndDelay(encodedAsLong, Utils.longToBinary(encodedAsLong));
  }


  public constructor (encodedAsLong: number, encodedAsBinary: string){

    // IntervalAndDelay res = new IntervalAndDelay();
  this.m_OriginalEncodedAsLong = encodedAsLong;
  this.m_EncodedAsBinaryString = encodedAsBinary;

  let bitIndex = 0;
  while (true) {
      const idxOrig =  encodedAsBinary.length - 1 - bitIndex;
      if (idxOrig < 0) {
        break;
      }
      if (this._isChar1(encodedAsBinary, idxOrig)) {
      // 1 bit before
      if (this._isChar1(encodedAsBinary, idxOrig + 1)) {
        this.addExtremity(ExtremityTypeOfInterval.END_OF_INTERVAL, bitIndex);
      }
      // 1 bit after
      if (this._isChar1(encodedAsBinary, idxOrig - 1)) {
        this.addExtremity(ExtremityTypeOfInterval.START_OF_INTERVAL, bitIndex);
      }
    }
    bitIndex++;
    }
  }




  public hasBitContent(bitIndex: number): boolean{
    const idxOrig = this.m_EncodedAsBinaryString.length - 1 - bitIndex;
    if (idxOrig < 0) {
      return false;
    }
    return true;
  }

  public isBitSet(bitIndex: number): boolean {
    const idxOrig = this.m_EncodedAsBinaryString.length - 1 - bitIndex;
    if (idxOrig < 0) {
      return false;
    }
    if (this.m_EncodedAsBinaryString[idxOrig] === '1') {
      return true;
    }
    return false;
  }

  private _isChar1(s: string, idx: number): boolean {
    if (((idx) >= 0) && ((idx) < s.length)) {
      if (s[idx] === '1') {
        return true;
      }
    }
    return false;
  }



  public retrieveExtremity(bitIndex: number): ExtremityTypeOfInterval {
      return this.map.get(bitIndex);
  }

  public addExtremity( extremity: ExtremityTypeOfInterval, bitIndex: number) {
    if (!this.map.get(bitIndex)) {
      this.map.set(bitIndex, extremity);
    }else {
      this.map.set(bitIndex, ExtremityHelper.add(this.map.get(bitIndex), extremity));
      // map.put(bitIndex,map.get(bitIndex).add(extremity)); // Adding Extremity
    }
  }


  public removeExtremity( extremity: ExtremityTypeOfInterval , bitIndex: number): boolean{
    if (this.map.get(bitIndex)) {
      const res = ExtremityHelper.remove(this.map.get(bitIndex), extremity);
      if (res) {
        if (res === this.map.get(bitIndex)) {
          // Nothing changed.
          return false;
        }
        if (res === ExtremityTypeOfInterval.NONE) {
          this.map.delete(bitIndex);
          return true;
        }else{
          this.map.set(bitIndex, res);
          return true;
        }
      } else {
        this.map.delete(bitIndex);
        return true;
      }
    }else{
      return false;
    }
  }

  public hasAnExtremity(bitIndex: number): boolean {
    if (this.map.get(bitIndex)) {
        return true;
    }
    return false;
  }


  public asExtremityString(): string {
    let res = '';

    let bitIndex = 0;
    while (true) {
      const idxOrig = this.m_EncodedAsBinaryString.length - 1 - bitIndex;
      if (idxOrig < 0) {
        break;
      }
      const extremityTypeOfInterval = this.retrieveExtremity(bitIndex);
      if (!extremityTypeOfInterval) {
        res = '0' + res;
      }else if (ExtremityTypeOfInterval.NONE === extremityTypeOfInterval) {
        res = '0' + res;
      }else if (ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL === extremityTypeOfInterval) {
        res = '|' + res;
      }else if (ExtremityTypeOfInterval.START_OF_INTERVAL === extremityTypeOfInterval) {
        res = ']' + res;
      }else if (ExtremityTypeOfInterval.END_OF_INTERVAL === extremityTypeOfInterval) {
        res = '[' + res;
      }
      bitIndex++;
    }
    return res;
  }

  public getEncodedAsLong(): number{
  let res = '';

  let bitIndex = 0;
  while (true) {
    const idxOrig = this.m_EncodedAsBinaryString.length - 1 - bitIndex;
    if (idxOrig < 0) {
      break;
    }
    const extremityTypeOfInterval = this.retrieveExtremity(bitIndex);
    if (!extremityTypeOfInterval) {
      res = '0' + res;
    }else if (ExtremityTypeOfInterval.NONE === extremityTypeOfInterval) {
      res = '0' + res;
    }else if (ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL === extremityTypeOfInterval) {
      res = '1' + res;
    }else if (ExtremityTypeOfInterval.START_OF_INTERVAL === extremityTypeOfInterval) {
      res = '1' + res;
    }else if (ExtremityTypeOfInterval.END_OF_INTERVAL === extremityTypeOfInterval) {
      res = '1' + res;
    }
    bitIndex++;
  }
  return Utils.binaryToLong(res);
}


  public calculateNbIntervals(): number {
    let bitIndex = 0;
    let nbStart = 0;
    let nbEnd = 0;
    while (true) {
      const idxOrig = this.m_EncodedAsBinaryString.length - 1 - bitIndex;
      if (idxOrig < 0) {
        break;
      }
      const extremityTypeOfInterval = this.retrieveExtremity(bitIndex);
      if (ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL === extremityTypeOfInterval){
        nbStart ++;
        nbEnd ++;
      }else if (ExtremityTypeOfInterval.START_OF_INTERVAL === extremityTypeOfInterval) {
        nbStart ++;
      }else if (ExtremityTypeOfInterval.END_OF_INTERVAL === extremityTypeOfInterval) {
        nbEnd ++;
      }
      bitIndex++;
    }
    if (nbEnd !== nbStart) {
      console.log('Nb Start and Nb end should be the same. Start: ' + nbStart + ' end: ' + nbEnd);
      // LOG.error("Nb Start and Nb end should be the same. Start: " + nbStart + " end: " + nbEnd);
    }
    return nbStart;
  }



  public formatAsString(de: DateEncoding): string {
    let res = '';
    // SimpleDateFormat SDF = new SimpleDateFormat("HH:mm");
    let bitIndex = 0;
    while (true) {
      const idxOrig = this.m_EncodedAsBinaryString.length - 1 - bitIndex;
      if (idxOrig < 0) {
        break;
      }
      const extremityTypeOfInterval = this.retrieveExtremity(bitIndex);
      if (ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL === extremityTypeOfInterval){
      //                //
      //                res += de.bitToDate(bitIndex);
      //                if (res.length()>0){
      //                    res +=", ";
      //                }
      //                res += de.bitToDate(bitIndex) + "-";
      //                res = "1" + res;
      }else if (ExtremityTypeOfInterval.START_OF_INTERVAL === extremityTypeOfInterval){
        if (res.length > 0) {
          res += ', ';
        }
        res += moment(de.bitToDate(bitIndex)).format('LT') + '-';
      }else if (ExtremityTypeOfInterval.END_OF_INTERVAL === extremityTypeOfInterval){
        res += moment(de.bitToDate(bitIndex)).format('LT');
      }
      bitIndex++;
    }
    return res;
  }

  public formatAsDate(de: DateEncoding): Date[]{
    const res = new Array<Date>();
    let bitIndex = 0;
    while (true) {
      const idxOrig = this.m_EncodedAsBinaryString.length - 1 - bitIndex;
      if (idxOrig < 0) {
        break;
      }
      const extremityTypeOfInterval = this.retrieveExtremity(bitIndex);
      if (ExtremityTypeOfInterval.START_AND_END_OF_INTERVAL === extremityTypeOfInterval) {
  //                //
  //                res += de.bitToDate(bitIndex);
  //                if (res.length()>0){
  //                    res +=", ";
  //                }
  //                res += de.bitToDate(bitIndex) + "-";
  //                res = "1" + res;
      }else if (ExtremityTypeOfInterval.START_OF_INTERVAL === extremityTypeOfInterval) {
        res.push(de.bitToDate(bitIndex));
      }else if (ExtremityTypeOfInterval.END_OF_INTERVAL === extremityTypeOfInterval) {
        res.push(de.bitToDate(bitIndex));
      }
      bitIndex++;
    }
    return res;
  }


  public length(): number{
    return this.m_EncodedAsBinaryString.length;
  }


  public toEncodedAsBinaryString(): string {
    let res = '';
    for (let idx = 0; idx < this.m_EncodedAsBinaryString.length; idx++) {
      res += this.m_EncodedAsBinaryString[idx] + '';
    }
    return res;
  }

  public remove(toRemove: IntervalAndDelay ): IntervalAndDelay {
    let bitIndex = 0;
      while (true) {
        if (!this.hasBitContent(bitIndex) || !toRemove.hasBitContent(bitIndex)) {
          break;
        }
        if (toRemove.isBitSet(bitIndex)) {
          if (this.isBitSet(bitIndex)){
            if (this.hasAnExtremity(bitIndex) && toRemove.hasAnExtremity(bitIndex)) {
              const thisExtremity = this.retrieveExtremity(bitIndex);
              const toRemoveExtremity = toRemove.retrieveExtremity(bitIndex);
              if ((ExtremityTypeOfInterval.END_OF_INTERVAL === toRemoveExtremity) && (ExtremityTypeOfInterval.START_OF_INTERVAL === thisExtremity)){
                bitIndex++;
                continue;
              }
              if (this.removeExtremity(ExtremityTypeOfInterval.START_OF_INTERVAL, bitIndex)) {
                toRemove.removeExtremity(ExtremityTypeOfInterval.START_OF_INTERVAL, bitIndex);
                if (this.removeExtremity(ExtremityTypeOfInterval.END_OF_INTERVAL, bitIndex + 1 )) {
                  toRemove.removeExtremity(ExtremityTypeOfInterval.END_OF_INTERVAL, bitIndex + 1);
                }
              }
            }
          }
        }
        bitIndex++;
      }
    return toRemove;
  }




  public intersects(intervalAndDelay: IntervalAndDelay ): boolean{

    const l1 = this.getEncodedAsLong();
    const l2 = intervalAndDelay.getEncodedAsLong();

    if (l1 === l2) {
      return true;
    }
    const res = l1 & l2;

    if (res > 0 ) {
      //return true;

      let idxOrig = 0;
      if (this.m_EncodedAsBinaryString.length>intervalAndDelay.m_EncodedAsBinaryString.length){
        idxOrig = intervalAndDelay.m_EncodedAsBinaryString.length - 1;
      }else{
        idxOrig = this.m_EncodedAsBinaryString.length - 1;
      }
      const extremityTypeOfInterval = this.retrieveExtremity(idxOrig);
      const candidateTypeOfInterval = intervalAndDelay.retrieveExtremity(idxOrig);
      if (ExtremityTypeOfInterval.START_OF_INTERVAL === candidateTypeOfInterval){
        if (ExtremityTypeOfInterval.END_OF_INTERVAL === extremityTypeOfInterval){
          return false;
        }
      }
      if (ExtremityTypeOfInterval.END_OF_INTERVAL === candidateTypeOfInterval){
        if (ExtremityTypeOfInterval.START_OF_INTERVAL === extremityTypeOfInterval){
          return false;
        }
      }

      return true;

      /*
       if (res>0){
            // Doesn't include doesn't mean they are not intersecting.
            // We need to verify that 10:00-12:00 and 12:00-14:00 is not the situation.
            //   [||||]
            // [|||]
            // Is Intersection

            // [|||]
            //     [||]  Is not an intersection
            int idxOrig = 0;
            if (m_EncodedAsBinaryString.length>candidate.m_EncodedAsBinaryString.length){
                idxOrig = candidate.m_EncodedAsBinaryString.length - 1;
            }else{
                idxOrig = m_EncodedAsBinaryString.length - 1;
            }
            ExtremityTypeOfInterval extremityTypeOfInterval = retrieveExtremity(idxOrig);
            ExtremityTypeOfInterval candidateTypeOfInterval = candidate.retrieveExtremity(idxOrig);
            if (ExtremityTypeOfInterval.START_OF_INTERVAL.equals(candidateTypeOfInterval)){
                if (ExtremityTypeOfInterval.END_OF_INTERVAL.equals(extremityTypeOfInterval)){
                    return false;
                }
            }
            if (ExtremityTypeOfInterval.END_OF_INTERVAL.equals(candidateTypeOfInterval)){
                if (ExtremityTypeOfInterval.START_OF_INTERVAL.equals(extremityTypeOfInterval)){
                    return false;
                }
            }

            return true;
        }

       */


    }else{
      return false;
    }
  }

/**
 * [|||||]0[|||||]
 *    [||]0[|]
 *    MUST return true.
 */
public includes(candidate: IntervalAndDelay ): boolean{

  if (this.m_EncodedAsBinaryString.length < candidate.m_EncodedAsBinaryString.length) {
    return false;
  }

  let foundStartOfCandidate = false;
  let foundEndOfCandidate = false;

  let bitIndex = 0;
  // let nbStart = 0;
  // let nbEnd = 0;
  while (true) {
    const idxOrig = this.m_EncodedAsBinaryString.length - 1 - bitIndex;
    if (idxOrig < 0) {
      break;
    }
    const extremityTypeOfInterval = this.retrieveExtremity(bitIndex);
    const candidateTypeOfInterval = candidate.retrieveExtremity(bitIndex);

    if (ExtremityTypeOfInterval.START_OF_INTERVAL === candidateTypeOfInterval){
      if (!foundStartOfCandidate) {
        // extrmityTypeOfInterval can be START or START_AND_END but not END only
        if ((!extremityTypeOfInterval) || (ExtremityTypeOfInterval.END_OF_INTERVAL === extremityTypeOfInterval)){
          return false;
        }
        foundStartOfCandidate = true;
        bitIndex++;
        continue;
      }
    }

    if (ExtremityTypeOfInterval.END_OF_INTERVAL === candidateTypeOfInterval){
      if (!foundEndOfCandidate) {
        // extremityTypeOfInterval can be END or START_AND_END but not START only
        if ((!extremityTypeOfInterval) || (ExtremityTypeOfInterval.START_OF_INTERVAL === extremityTypeOfInterval)){
          return false;
        }
        foundEndOfCandidate = true;
        bitIndex++;
        continue;
      }
    }

    if ((candidateTypeOfInterval) && (candidateTypeOfInterval !== extremityTypeOfInterval)){
      return false;
    }
    bitIndex++;
  }
  // if (nbEnd !== nbStart) {
  //   console.log('Nb Start and Nb end should be the same. Start: ' + nbStart + ' end: ' + nbEnd);
  //   return false;
  // }
  return true;

}




}

/*
ExtremityTypeOfInterval add( ExtremityTypeOfInterval toBeAdded){
  if (this.equals(toBeAdded)){
    return this;
  }
  switch (toBeAdded){
    case END_OF_INTERVAL:
      if (START_OF_INTERVAL.equals(this)){
        return START_AND_END_OF_INTERVAL;
      }
      return this;
    case START_OF_INTERVAL:
      if (END_OF_INTERVAL.equals(this)){
        return START_AND_END_OF_INTERVAL;
      }
      return this;
    default:
      return START_AND_END_OF_INTERVAL;
  }
}

ExtremityTypeOfInterval remove(ExtremityTypeOfInterval toBeRemoved){
  if (this.equals(toBeRemoved)){
    return null;
  }
  switch (toBeRemoved){
    case END_OF_INTERVAL:
      if (START_AND_END_OF_INTERVAL.equals(this)){
        return START_OF_INTERVAL;
      }
      return this;
    case START_OF_INTERVAL:
      if (START_AND_END_OF_INTERVAL.equals(this)){
        return END_OF_INTERVAL;
      }
      return this;
  }
  return null;
}


}
*/
